module.exports = __webpack_public_path__ + "img/creative-menu-block-red.4a6a9dac.png";